import { ContactFormData } from 'modules/types/ContactFormData';
import { axiosInstance } from './axios';
import { REACT_APP_API_SERVER_URL } from './constants';

export const sendContactMessage = async (contactFormData: ContactFormData) => {
  const body = {
    firstName: contactFormData.firstName,
    lastName: contactFormData.lastName,
    phoneNumber: contactFormData.phone,
    email: contactFormData.email,
    contractNumber: contactFormData.contractNumber,
    message: contactFormData.message,
  };

  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/contact/send-email`,
    body,
  );

  return response.status === 200;
};
